import { Typography } from '@mui/material';
import React, { PropsWithChildren } from 'react';

export default function BaseSelector(props: PropsWithChildren) {
  return (
    <Typography
      sx={{
        paddingLeft: 2,
        paddingRight: 2,
      }}>
      {props.children}
    </Typography>
  );
}
